import PropTypes from 'prop-types'
import React from 'react'

import InformationContainer from '../../components/informationContainer/InformationContainer'
import { useTranslation } from '../../utils/useTranslation'
import { Column, Link, MobileLink, Row, Span, Value } from './common'

const UserStore = ({
  storeName,
  email,
  phoneNumber,
  address,
  showStoreLink,
  customPadding,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <InformationContainer
        title={showStoreLink ? t('app.pages.user-settings.store.heading') : ''}
        padding={!showStoreLink && customPadding}
      >
        <Column>
          <Row>
            <Value>{storeName}</Value>
          </Row>
        </Column>
        <Column>
          <MobileLink href={`mailto:${email}`}>{email}</MobileLink>
          <Span>{email}</Span>
        </Column>
        <Column>
          <MobileLink href={`tel:${phoneNumber}`} target="_blank">
            {phoneNumber}
          </MobileLink>
          <Span>{phoneNumber}</Span>
        </Column>
        {showStoreLink && (
          <Column>
            <Link
              href={`https://maps.google.com/?q=${address}`}
              target="_blank"
            >
              {address}
            </Link>
          </Column>
        )}
      </InformationContainer>
    </>
  )
}
UserStore.defaultProps = {
  storeName: '',
  email: '',
  phoneNumber: '',
  address: '',
  showStoreLink: true,
  customPadding: '',
}

UserStore.propTypes = {
  storeName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  showStoreLink: PropTypes.bool,
  customPadding: PropTypes.string,
}

export default UserStore
